<div *ngIf="!loadingData">
    <app-spinner></app-spinner>
</div>

<div *ngIf="course && loadingData">
    
    <!-- Title -->
    <mat-toolbar class="custom-course-detail-title">
        
        <div class="d-flex flex-row justify-content-start align-items-center h-100 w-100">
            <a class="h-100" *ngIf="courseIconPath">
                <img class="custom-course-detail-icon h-100 p-2 me-1" [src]="courseIconPath">
            </a>
            <span>{{ course.name }}</span>
        </div>
        
        <div class="d-flex flex-row justify-content-end align-items-center h-100 w-100">
            <a mat-raised-button class="custom-course-detail-title-button"[routerLink]="['../']">
                <span class="material-icons">keyboard_backspace</span>
                Volver a los cursos
            </a>
        </div>

    </mat-toolbar>

    <!-- Content -->
    <div class="container my-3"> 

        <!-- Summary -->
        <div class="row mb-2"> 
            
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 h-75">

                <div class="alert alert-success d-flex flex-wrap flex-row justify-content-start align-items-center h-100 w-100">

                    <!-- Area -->
                    <div *ngIf="course.area" class="badge align-self-stretch p-2 me-2" [ngClass]="areaBadgeClass">
                        <div class="d-flex flex-row justify-content-start align-items-center h-100 w-100">
                            <img *ngIf="areaIconPath" 
                                class="custom-course-detail-area-icon align-self-center me-2 h-100" 
                                [src]="areaIconPath">
                            <span class="align-self-center">Área de {{ course.area.name }}</span>
                        </div>
                    </div>
                        
                    <!-- Language -->
                    <!-- <div *ngIf="course.language" class="badge bg-secondary align-self-stretch p-2 me-2">
                        <div class="d-flex flex-row justify-content-start align-items-center h-100 w-100">
                            <img *ngIf="course.language.iconPath"
                                class="custom-course-detail-language-icon align-self-center me-2 h-100" 
                                [src]="course.language.iconPath"
                                [title]="'Curso en ' + course.language.name.toLowerCase()">
                            <span class="align-self-center">Curso en {{ course.language.name.toLowerCase() }}</span>
                        </div>
                    </div> -->
                        
                    <!-- Classification -->
                    <div *ngFor="let classification of course.classifications" class="badge bg-secondary align-self-stretch p-2 me-2">
                        <div class="d-flex flex-row justify-content-start align-items-center h-100 w-100">
                            <img *ngIf="classification.iconPath"
                                class="custom-course-detail-classification-icon align-self-center me-2 h-100" 
                                [src]="classification.iconPath">
                            <span class="align-self-center">{{ classification.name }}</span>
                        </div>
                    </div>

                </div>

            </div>

        </div>

        <!-- Requirements -->
        <div *ngIf="courseRequirements" class="row mb-2"> 
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <div class="alert alert-warning d-flex flex-row justify-content-start align-items-center border border-warning p-2 m-0">
                    <span class="material-icons align-self-center me-2">warning</span>
                    <span class="align-self-center" [innerHTML]="courseRequirements"></span>
                </div>
            </div>
        </div>
        
        <!-- Requirements -->
        <div class="row mb-2">

            <div *ngIf="courseOnlineTechnicalRequirements" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 mb-2">
                <div class="custom-course-detail-online-requirements alert alert-warning d-flex flex-column justify-content-start align-items-center border border-warning h-100 p-2 m-0">
                    <h4>Requisitos técnicos</h4>
                    <div class="lh-sm w-100" [innerHTML]="courseOnlineTechnicalRequirements"></div>
                </div>
            </div>

            <div *ngIf="courseOnlineUserRequirements" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 mb-2">
                <div class="custom-course-detail-online-requirements alert alert-warning d-flex flex-column justify-content-start align-items-center border border-warning h-100 p-2 m-0">
                    <h4>Conocimientos como usuario</h4>
                    <div class="lh-sm w-100" [innerHTML]="courseOnlineUserRequirements"></div>
                </div>
            </div>

            <div *ngIf="courseOnlineSoftwareRequirements" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 mb-2">
                <div class="custom-course-detail-online-requirements alert alert-warning d-flex flex-column justify-content-start align-items-center border border-warning h-100 p-2 m-0">
                    <h4>Instalación de software</h4>
                    <div class="lh-sm w-100" [innerHTML]="courseOnlineSoftwareRequirements"></div>
                </div>
            </div>

        </div>

        <!-- Description -->
        <div class="row custom-course-detail-description p-3">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-0">
                <span class="lh-sm" [innerHTML]="courseDescription"></span>
            </div>
        </div>

        <!-- PDF Viewer -->
        <div *ngIf="safeCoursePdfPath" class="row custom-course-detail-pdf-viewer pb-4">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-0">
                <div class="d-flex flex-column justify-content-center p-3">
                    <ngx-extended-pdf-viewer
                        theme="dark"
                        backgroundColor="#5c5c5c"
                        [height]="'80vh'"
                        [src]="coursePdfPath"
                        [useBrowserLocale]="true"
                        [textLayer]="true"
                        [showZoomButtons]="true"
                        [mobileFriendlyZoom]="'150%'"
                        [enablePinchOnMobile]="true"
                        [minZoom]="0.5"
                        [maxZoom]="1.5"
                        [showPrintButton]="true"
                        [showDownloadButton]="true"
                        [showZoomButtons]="true"
                        [showScrollingButton]="false"
                        [showSecondaryToolbarButton]="false"
                        [showSidebarButton]="false"
                        [showFindButton]="false"
                        [showPagingButtons]="false"
                        [showPresentationModeButton]="false"
                        [showOpenFileButton]="false"
                        [showBookmarkButton]="false"
                        [showRotateButton]="false"
                        [showHandToolButton]="false"
                        [showSpreadButton]="false"
                        [showPropertiesButton]="false">
                    </ngx-extended-pdf-viewer>
                </div>
            </div>
        </div>

    </div>

</div>

